export default function ProductGridSkeleton({ count = 8 }) {
  return (
    <div className="product-grid" aria-label="Carregando produtos">
      {Array.from({ length: count }, (_, index) => (
        <div className="product-card product-card--skeleton" key={index}>
          <div className="skeleton skeleton--media" />
          <div className="product-card__body">
            <div className="skeleton skeleton--eyebrow" />
            <div className="skeleton skeleton--title" />
            <div className="skeleton skeleton--text" />
            <div className="skeleton skeleton--price" />
          </div>
        </div>
      ))}
    </div>
  );
}
